import { createStore } from 'vuex';
import VueCookies from 'vue-cookies';
import UserAccountStore from '@/store/modules/UserAccountStore';
import EnCodingStore from './modules/EnCodingStore';

export default createStore({
    // 상태
    state: {
        user: {
            data: null,
            loggedIn: !!VueCookies.get('loggedIn'),
        },
    },
    // 상태 변경 관리
    mutations: {
        setUser(state, data) {
            state.user.data = data;
            VueCookies.set('nttworks_access_token', data.access_token);
            VueCookies.set('nttworks_refresh_token', data.refresh_token);
            VueCookies.set('nttworks_user_id', data.user_id);
            VueCookies.set('nttworks_autoLogin', data.autoLogin);
            VueCookies.set('nttworks_display_name', data.display_name);
            VueCookies.set('nttworks_user_name', data.user_name);
            VueCookies.set('nttworks_comp_id', data.comp_id);
            VueCookies.set('nttworks_auth', data.auth);
            VueCookies.set('nttworks_thumb', data.thumb);
            VueCookies.set('nttworks_emr_color', data.emr_color);
            VueCookies.set('nttworks_stt_color', data.stt_color);
            VueCookies.set('nttworks_melody', data.melody);
            VueCookies.set('nttworks_sound', data.sound);
            VueCookies.set('nttworks_rows_per_page', data.rows_per_page);
        },
        setLoggedIn(state, value) {
            state.user.loggedIn = value;
            VueCookies.set('loggedIn', value);
        },
        logoutUser(state) {
            state.user.data = null;
            state.user.loggedIn = false;
            VueCookies.remove('nttworks_access_token');
            VueCookies.remove('nttworks_refresh_token');
            VueCookies.remove('nttworks_user_id');
            VueCookies.remove('nttworks_autoLogin');
            VueCookies.remove('nttworks_display_name');
            VueCookies.remove('nttworks_user_name');
            VueCookies.remove('nttworks_comp_id');
            VueCookies.remove('nttworks_auth');
            VueCookies.remove('nttworks_thumb');
            VueCookies.remove('loggedIn');
            VueCookies.remove('nttworks_emr_color');
            VueCookies.remove('nttworks_stt_color');
            VueCookies.remove('nttworks_melody');
            VueCookies.remove('nttworks_sound');
            VueCookies.remove('nttworks_rows_per_page');
        },
        resetUserInfo(state, data) {
            if (state.user.data == null) {
                state.user.data = data;
                VueCookies.set('nttworks_access_token', data.access_token);
                VueCookies.set('nttworks_refresh_token', data.refresh_token);
                VueCookies.set('nttworks_user_id', data.user_id);
                VueCookies.set('nttworks_autoLogin', data.autoLogin);
                VueCookies.set('nttworks_display_name', data.display_name);
                VueCookies.set('nttworks_user_name', data.user_name);
                VueCookies.set('nttworks_comp_id', data.comp_id);
                VueCookies.set('nttworks_auth', data.auth);
                VueCookies.set('nttworks_thumb', data.thumb);
                VueCookies.set('nttworks_emr_color', data.emr_color);
                VueCookies.set('nttworks_stt_color', data.stt_color);
                VueCookies.set('nttworks_melody', data.melody);
                VueCookies.set('nttworks_sound', data.sound);
                VueCookies.set('nttworks_rows_per_page', data.rows_per_page);
            }
        },
        resetAdminProfile(state, data) {
            state.user.data.comp_id = data.comp_id;
            state.user.data.display_name = data.display_name;
            VueCookies.remove('nttworks_comp_id');
            VueCookies.remove('nttworks_display_name');
            VueCookies.set('nttworks_comp_id', data.comp_id);
            VueCookies.set('nttworks_display_name', data.display_name);
        },
        resetProfile(state, data) {
            state.user.data.thumb = data.thumb;
            VueCookies.remove('nttworks_thumb');
            VueCookies.set('nttworks_thumb', data.thumb);
        },
        resetColors(state, data) {
            state.user.data.emr_color = data.emr_color;
            state.user.data.stt_color = data.stt_color;
            VueCookies.remove('nttworks_emr_color');
            VueCookies.remove('nttworks_stt_color');
            VueCookies.set('nttworks_emr_color', data.emr_color);
            VueCookies.set('nttworks_stt_color', data.stt_color);
        },
        resetSound(state, data) {
            state.user.data.melody = data.melody;
            state.user.data.sound = data.sound;
            VueCookies.remove('nttworks_melody');
            VueCookies.remove('nttworks_sound');
            VueCookies.set('nttworks_melody', data.melody);
            VueCookies.set('nttworks_sound', data.sound);
        },
        resetPage(state, data) {
            state.user.data.rows_per_page = data.rows_per_page;
            VueCookies.remove('nttworks_rows_per_page');
            VueCookies.set('nttworks_rows_per_page', data.rows_per_page);
        },
    },
    getters: {
        user(state) {
            return state.user;
        },
    },
    modules: {
        UserAccountStore: UserAccountStore,
        EnCodingStore: EnCodingStore,
    },
});
